// Legacy path. Please use `qr-code` instead.
// Keep file here in case developer import directly from the old path.
export * from '../../qr-code/style';
